module.exports = window['navigation-header'];